export default __webpack_public_path__ + "static/media/exchange.9563c479.svg";